"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SimpleProblemLoggingInFormComponent = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reduxForm = require("redux-form");
var _APInput = _interopRequireDefault(require("../common/APInput"));
var _APButton = _interopRequireDefault(require("../common/APButton"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _APRadio = _interopRequireDefault(require("../common/APRadio/APRadio"));
var _formValidations = require("../../helpers/formValidations");
var _commonComponent = require("../../propTypes/commonComponent");
require("../../styles/components/common/StandaloneForm.css");
require("./SimpleProblemLoggingInForm.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('standalone-form');
var simpleProblemLoggingInFormClasses = (0, _cssClassesHelper.getBEMClasses)('forgot-password-form');
var SimpleProblemLoggingInFormComponent = exports.SimpleProblemLoggingInFormComponent = /*#__PURE__*/function (_React$Component) {
  function SimpleProblemLoggingInFormComponent(props) {
    var _this;
    _classCallCheck(this, SimpleProblemLoggingInFormComponent);
    _this = _callSuper(this, SimpleProblemLoggingInFormComponent, [props]);
    _defineProperty(_this, "toggleFormType", function () {
      return _this.setState({
        resetPassword: !_this.state.resetPassword
      });
    });
    _defineProperty(_this, "sendEmail", function (values) {
      var _this$props = _this.props,
        sendResetPasswordEmail = _this$props.sendResetPasswordEmail,
        resendVerificationEmail = _this$props.resendVerificationEmail;
      if (_this.state.resetPassword) {
        return sendResetPasswordEmail(values.Email);
      }
      return resendVerificationEmail(values);
    });
    _this.state = {
      resetPassword: true
    };
    return _this;
  }
  _inherits(SimpleProblemLoggingInFormComponent, _React$Component);
  return _createClass(SimpleProblemLoggingInFormComponent, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props2 = this.props,
        handleSubmit = _this$props2.handleSubmit,
        submitting = _this$props2.submitting,
        pristine = _this$props2.pristine,
        invalid = _this$props2.invalid;
      var _this$props3 = this.props,
        useEmailAsUsername = _this$props3.useEmailAsUsername,
        showOptions = _this$props3.showOptions;
      var validate = [_formValidations.required];
      var label = t("Username");
      if (useEmailAsUsername || !this.state.resetPassword) {
        validate.push(_formValidations.email);
        label = t("Email");
      }
      return /*#__PURE__*/_react["default"].createElement(_reduxForm.Form, {
        onSubmit: handleSubmit(this.sendEmail),
        className: "".concat(baseClasses('form'), " ").concat(simpleProblemLoggingInFormClasses('form'))
      }, showOptions ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(baseClasses('information-text'), " ").concat(simpleProblemLoggingInFormClasses('information-text'))
      }, t("Select your issue type and provide us with your {{label}} below. We will follow up with a solution shortly.", {
        label: label.toLowerCase()
      })), /*#__PURE__*/_react["default"].createElement("hr", {
        className: baseClasses('separator')
      }), /*#__PURE__*/_react["default"].createElement("section", {
        className: baseClasses('radio-list')
      }, /*#__PURE__*/_react["default"].createElement(_APRadio["default"], {
        name: "type",
        checked: this.state.resetPassword,
        onChange: this.toggleFormType,
        customClass: simpleProblemLoggingInFormClasses(),
        label: t("I’m an existing user and I forgot my password."),
        id: "problem-login-radio1"
      }), /*#__PURE__*/_react["default"].createElement(_APRadio["default"], {
        name: "type",
        checked: !this.state.resetPassword,
        onChange: this.toggleFormType,
        customClass: simpleProblemLoggingInFormClasses(),
        label: t("I’m a new user and I haven’t received my verification email."),
        id: "problem-login-radio2"
      }))) : /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(baseClasses('information-text'), " ").concat(simpleProblemLoggingInFormClasses('information-text'))
      }, t("Provide us with your {{label}} below. We will follow up with reset instructions.", {
        label: label.toLowerCase()
      })), /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
        type: "text",
        name: "Email",
        customClass: simpleProblemLoggingInFormClasses(),
        label: label,
        validate: validate
      }), /*#__PURE__*/_react["default"].createElement("hr", {
        className: simpleProblemLoggingInFormClasses('separator')
      }), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        type: "submit",
        disabled: submitting || pristine || invalid,
        customClass: simpleProblemLoggingInFormClasses(),
        styleName: _commonComponent.styleNames.additive
      }, submitting ? t("Processing...") : t("Send Email")));
    }
  }]);
}(_react["default"].Component);
SimpleProblemLoggingInFormComponent.propTypes = {
  handleSubmit: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)("auth")(SimpleProblemLoggingInFormComponent);